import { render } from "./SetLicense.vue?vue&type=template&id=6678f7b5"
import script from "./SetLicense.vue?vue&type=script&lang=js"
export * from "./SetLicense.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dima/Documents/mybackup/backup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__